import styled from 'styled-components';
import { ASSETS } from 'utils/config';

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 35vw;
  box-shadow: 24px 24px 48px rgba(0, 0, 0, 0.2);
  padding: 20px;
  border-radius: 14px;
  background-color: white;
  background-size: cover;
  position: relative;
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  position: relative; /* Ensure positioning inside header */

  .close-icon {
    cursor: pointer;
    color: #757575;
    transition: color 0.2s;

    &:hover {
      color: #000;
    }
  }
`;

export const CrownIcon = styled.img`
  width: 20px; /* Adjust to desired size */
  height: 20px; /* Adjust to desired size */
  margin-right: 10px; /* Space between the crown icon and text */
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: left;
  gap: 10px;
`;
